<div class="modals" [class.modals-show]="showDeliveryDate">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="flex-container">
    <div class="select-wrapper">
      <select
        [class.border-wrong]="wrongDeliveryDates"
        [(ngModel)]="selectedDate"
        (change)="changeDeliveryDate()"
      >
        <option value="-1">Виберіть дату відправки</option>
        <option [value]="delDate" *ngFor="let delDate of deliveryDate">
          {{ delDate }}
        </option>
      </select>
      <span class="status" [class.status-error]="wrongDeliveryDates">
            Виберіть дату відправки
          </span>
    </div>

    <div *ngIf="deliveryHoursList.length" class="select-wrapper">
      <select
        [class.border-wrong]="wrongDeliveryHours"
        [(ngModel)]="selectedHours"
        (change)="validationDeliveryHours()"
      >
        <option value="-1">Виберіть час відправки</option>
        <option *ngFor="let delHour of deliveryHoursList" [value]="delHour">
          {{ delHour }}:00
        </option>
      </select>
      <span class="status" [class.status-error]="wrongDeliveryHours">
            Виберіть час відправки
          </span>
    </div>
    <button class="button  center-btn" (click)="submitDeliveryDate()">Змінити</button>
  </div>
</div>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
